import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sm_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && localStorage.getItem("sm_token")) {
      localStorage.removeItem("sm_token");
      if (!window.location.pathname.startsWith("/r/") && !window.location.pathname.startsWith("/order")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export const money = (v) =>
  "₹" + Number(v || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const apiError = (err, fallback = "Something went wrong") => {
  const d = err?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ") || fallback;
  return typeof d === "string" ? d : fallback;
};

export const fileUrl = (path) => (path ? `${BACKEND_URL}${path}` : "");
